import { useAtomValue } from 'jotai'
import Image from 'next/image'
import {
  estimatedRemainingTimeTextAtom,
  fromWalletAtom,
  isUserRejectionErrorAtom,
  shouldExecuteNamadaUnshieldAtom,
  shouldUseGasStationAtom,
} from '@/src/stores/route-machine/atoms'
import { startTradeStepAtom } from '@/src/stores/trade/atoms'
import { BasicStep, BasicStepTitle } from './basic-step'

const Title = () => {
  const isSecondStep = useAtomValue(shouldUseGasStationAtom)
  const isUserRejectionError = useAtomValue(isUserRejectionErrorAtom)
  const shouldExecuteNamadaUnshield = useAtomValue(
    shouldExecuteNamadaUnshieldAtom,
  )

  const title = isUserRejectionError
    ? 'Approval rejected'
    : shouldExecuteNamadaUnshield
      ? 'Starting trade'
      : 'Start trade'

  return (
    <div className='flex items-center gap-1 py-1 w-full justify-between'>
      <BasicStepTitle title={title} isError={isUserRejectionError} />
      {isSecondStep && <span className='text-tertiary font-normal'>2/2</span>}
    </div>
  )
}

export const StartTradeStep = () => {
  const startTradeStep = useAtomValue(startTradeStepAtom)
  const isUserRejectionError = useAtomValue(isUserRejectionErrorAtom)
  const fromWalletDetails = useAtomValue(fromWalletAtom)
  const estimatedRemainingTimeText = useAtomValue(
    estimatedRemainingTimeTextAtom,
  )
  const shouldExecuteNamadaUnshield = useAtomValue(
    shouldExecuteNamadaUnshieldAtom,
  )
  const isWarning = startTradeStep.error && isUserRejectionError

  return (
    <BasicStep
      title={<Title />}
      isActive={startTradeStep.isActive}
      isLoading={startTradeStep.isLoading}
      isError={startTradeStep.isError}
      isWarning={isWarning}
      isWaiting={startTradeStep.isSigning}
      isSuccess={startTradeStep.isSuccess}
    >
      <div className='flex flex-col text-left gap-2'>
        {shouldExecuteNamadaUnshield ? (
          <h6 className='flex items-center gap-2 font-semibold text-primary text-xl'>
            <span>Approving</span>
          </h6>
        ) : (
          <h6 className='flex items-center gap-2 font-semibold text-primary text-xl'>
            <span>Approve in</span>
            {!!fromWalletDetails?.logoUrl && (
              <Image
                src={fromWalletDetails?.logoUrl}
                alt=''
                width={24}
                height={24}
                className='size-6'
                unoptimized
              />
            )}
            <span>{fromWalletDetails?.displayName}</span>
          </h6>
        )}
        {estimatedRemainingTimeText && !isWarning ? (
          <span className='text-secondary text-sm'>
            About{' '}
            <span className='text-primary'>{estimatedRemainingTimeText}</span>{' '}
            to complete
          </span>
        ) : null}
        {isWarning ? (
          <span className='text-secondary text-sm'>
            Retry in your wallet or cancel this trade
          </span>
        ) : null}
      </div>
    </BasicStep>
  )
}
